<template>

    <div>
        <van-divider />
        <van-row >
            <van-col span="19" >
                <span style="color: #969799">支出￥{{pay}} 收入￥{{income}}</span>
            </van-col>
            <van-col span="5" >
                <van-button icon="calender-o" plain type="info" size="small" :text="qryDate" @click="showDatePicker = true" color="#fe7844"></van-button>

            </van-col>
        </van-row>
        <van-popup v-model="showDatePicker" position="bottom">
            <van-picker
                    title="年份"
                    show-toolbar
                    :columns="yearColumns"
                    @confirm="onDateConfirm"
                    @cancel="showDatePicker = false"
                    :default-index=getDefaultIndex()
            />
        </van-popup>
        <van-divider />
        <fin-year-count @getParData="getParData($event)" :search-date="qryDate" view-id="yearCountId"></fin-year-count>
        <fin-year-sort @getParData="getSortData($event)" :search-date="qryDate" view-id="yearSortId"></fin-year-sort>
        <van-popup v-model="popupShow" round closeable position="bottom" :style="{ width: '100%',height: '80%' }" >
            <popup-fin-list :qry-data="qryData" :refresh-index="refreshIndex"></popup-fin-list>
        </van-popup>
        <div style="margin-bottom: 100px"></div>
    </div>
</template>

<script>
    import FinYearCount from "./FinYearCount";
    import FinYearSort from "./FinYearSort";
    import PopupFinList from "../report/PopupFinList";
    import * as DateUtil from '@/common/utils/dateUtil.js'
    import * as MyApi from '@/api/URLApiAddr.js'
    export default {
        name: "FinYearStatistics",
        components: {
            FinYearCount,
            FinYearSort,
            PopupFinList
        },
        data() {
            return {
                qryDate: new Date().getFullYear()+'',
                pickDate: new Date(),
                showDatePicker: false,
                yearColumns: DateUtil.getYear(),
                minDate: DateUtil.getMinDate(),
                maxDate: DateUtil.getMaxDate(),
                income: 0,
                pay: 0,
                popupShow: false,
                refreshIndex: 0,
                qryData:{

                }
            }
        },
        watch:{
            qryDate() {
                this.qryYearInfo()
            }

        },
        mounted(){
            this.qryYearInfo()
        },
        methods: {
            qryYearInfo() {
                let params = {year:this.qryDate}
                this.$axios.post(MyApi.QRY_FIN_YEAR_INFO,params/*,options*/)
                    .then((data) =>  {
                        //let data = response.data
                        if('200' == data.code){
                            let resData = data.data
                            if(resData){
                                this.income = resData.income
                                this.pay = resData.pay
                            }else{
                                this.income = 0
                                this.pay = 0
                            }
                        }

                    })
                    .catch((err) => {

                    })


            },
            onDateConfirm(value) {
                debugger
                this.qryDate = value + '';
                this.showDatePicker = false;
            },
            getParData(childData){
                debugger
                this.qryData = {}
                if(childData.belong){

                    this.qryData.belongs = [childData.belong]
                }
                this.qryData.year = this.qryDate
                this.qryData.finType = childData.finType
                if(childData.sort){
                    this.qryData.sorts = [childData.sort]
                }
                if(childData.sortDetail){
                    this.qryData.sortDetail = childData.sortDetail
                }
                this.refreshIndex ++
                this.popupShow = true

            },
            getDefaultIndex(){
                let fullYear = new Date().getFullYear();
                return DateUtil.getYear().indexOf(fullYear);
            },
            getSortData(childData){
                this.qryData = {}

                this.qryData.year = this.qryDate
                this.qryData.finType = childData.finType
                this.qryData.sortName = childData.sortName
                if(childData.sort){
                    this.qryData.sort = childData.sort
                }
                if(childData.detail){
                    this.qryData.details = [childData.detail]
                }
                if(childData.sortDetail || childData.detail){
                    this.refreshIndex ++
                    this.popupShow = true
                }
            },
        }
    }
</script>

<style scoped>

</style>
